import React from 'react';
import { IResultsContext } from '../Types/IResultsContext';
import {IResultsData} from '../Types/IResultsData';
import IVehicleType from '../Types/IVehicleType';
import {DEFAULT_SEARCH_RADIUS} from "../../Foundations/Constants/SearchRadius";

const resultsContext: React.Context<IResultsContext> = React.createContext({
    ref: '',
    results: [],
    resultSummary: null,
    isMapViewOpen: false,
    selectedItem: null,
    setResults: (val: IResultsData[]) => { return val },
    setMapView: (val: boolean) => { return val},
    setSelectedItem: (val: IResultsData | null) => val,
    depotsAtArea: [],
    suppliersAtArea: [],
    isLimited: false,
    limitedBy: null,
    availableVehicleTypes: [],
    setLimitedBy: (val: IVehicleType) => {return val},
    selectedRadius: DEFAULT_SEARCH_RADIUS * 1000,
    setSelectedRadius(val: number) {
        return val
    }
} as IResultsContext);

export default resultsContext;
